import { render, staticRenderFns } from "./RecommendCourse.vue?vue&type=template&id=1c9b4809&scoped=true&"
import script from "./RecommendCourse.vue?vue&type=script&lang=js&"
export * from "./RecommendCourse.vue?vue&type=script&lang=js&"
import style0 from "./RecommendCourse.vue?vue&type=style&index=0&id=1c9b4809&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9b4809",
  null
  
)

export default component.exports